import React from "react";

const AboutUs: React.FC = () => {
  return (
    <section className="w-full py-16 md:py-20 lg:py-24 bg-[#EFFFFD]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-[60px] lg:leading-[60px] font-bold text-center text-[#2C3E50] mb-4 font-['Inter']">
            About <span className="text-[#21A6B5]">MySalaryLoan</span>
          </h1>
          <div className="inline-block border-2 border-[#21A6B5] rounded-full px-8 py-3 mt-4">
            <p className="text-lg md:text-[20px] md:leading-[28px] text-center text-[#21A6B5] font-semibold font-['Inter']">
              Designed for real needs, not long waits.
            </p>
          </div>
        </div>

        {/* Description Paragraphs */}
        <div className="max-w-5xl mx-auto space-y-6 mb-12 md:mb-16">
          <p className="text-base md:text-[20px] md:leading-[29.25px] font-normal text-gray-800 leading-relaxed font-['Inter']">
            <span className="text-[#21A6B5] font-bold">MySalaryLoan</span> is a digital lending platform created exclusively for salaried professionals who need quick access to funds during unexpected moments before payday, during emergencies, or when plans can't wait.
          </p>
          <p className="text-base md:text-[20px] md:leading-[29.25px] font-normal text-gray-800 leading-relaxed font-['Inter']">
            We understand that traditional loans often involve delays, paperwork, and unclear terms. That's why MySalary Loan focuses on simplicity, speed, and complete transparency. From eligibility checks to disbursal, every step is designed to be seamless, digital, and easy to understand.
          </p>
        </div>

        {/* Features Strip */}
        <div className="bg-gradient-to-r from-[#5DADE2] to-[#21A6B5] rounded-3xl py-6 md:py-8 px-6 md:px-12 mb-12 md:mb-16">
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-white">
            <span className="text-lg md:text-[24px] md:leading-[28px] font-semibold font-['Inter']">Transparent Terms & Fair Pricing</span>
            <span className="text-2xl">•</span>
            <span className="text-lg md:text-[24px] md:leading-[28px] font-semibold font-['Inter']">Secure & Private</span>
            <span className="text-2xl">•</span>
            <span className="text-lg md:text-[24px] md:leading-[28px] font-semibold font-['Inter']">Digital-First Process</span>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-[#5DADE2] to-[#21A6B5] rounded-3xl p-8 md:p-12 lg:p-16 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 font-['Inter']">
            Your salary shouldn't make you wait.
          </h2>
          <p className="text-base md:text-lg text-white mb-6 md:mb-8 max-w-3xl mx-auto font-['Inter']">
            Instant approval, quick disbursal, and transparent terms designed for working professionals.
          </p>
          <a
            href={import.meta.env.VITE_WEBSITE_LINK}
            target="_blank"
            className="inline-block px-8 md:px-12 py-3 md:py-4 rounded-full bg-white text-[#3D4A7C] font-bold text-center text-base md:text-[18px] leading-[28px] hover:bg-gray-100 transition-colors shadow-lg font-['Inter']"
          >
            Get Funds Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
